export enum AgentMetaInfoType {
  ACTIVE_LISTINGS_COUNT = 'activeListingsCount',
  NO_ACTIVE_LISTINGS = 'noActiveListings',
  PROPERTIES_SOLD = 'propertiesSold',
  MEDIAN_PSF_AND_LISTING_PRICE = 'medianPsfAndListingPrice',
  DEMAND = 'demand',
}
